// ══════════════════════════════════════════════════════════
// ADMIN ENTITLEMENTS MOCK DATA
//
// Datos mock para la sección Premium del panel de admin.
// Incluye entitlements y solicitudes de app personalizada.
// ══════════════════════════════════════════════════════════

import type { BackendEntitlementsResponse } from '@/types/entitlements';
import type { CustomAppRequestResponse } from '@/types/customApps';

export const adminEntitlementsData: {
  entitlements: BackendEntitlementsResponse['entitlements'];
  customAppRequests: CustomAppRequestResponse[];
} = {
  entitlements: [
    { key: 'managed_streaming', enabled: true, limit: null, limit_unit: null },
    { key: 'autodj', enabled: true, limit: null, limit_unit: null },
    { key: 'extra_storage', enabled: true, limit: 500, limit_unit: 'GB' },
    { key: 'multiple_stations', enabled: false, limit: null, limit_unit: null },
    { key: 'advanced_cabina', enabled: true, limit: null, limit_unit: null },
    { key: 'podcasts', enabled: true, limit: 50, limit_unit: 'podcasts' },
    { key: 'contests', enabled: true, limit: 10, limit_unit: 'concursos' },
    { key: 'analytics', enabled: true, limit: null, limit_unit: null },
    { key: 'custom_domain', enabled: true, limit: null, limit_unit: null },
    { key: 'featured_radio', enabled: false, limit: null, limit_unit: null },
    { key: 'advanced_notifications', enabled: true, limit: null, limit_unit: null },
    { key: 'custom_app', enabled: true, limit: null, limit_unit: null },
  ],
  customAppRequests: [
    {
      id: 'car-001',
      radio_id: 'radio-nueva-actitud',
      status: 'APPROVED',
      app_name: 'Radio Nueva Actitud',
      platforms: ['ANDROID', 'IOS'],
      requested_at: '2026-05-10T14:30:00Z',
      updated_at: '2026-06-22T09:15:00Z',
      reviewer_notes: 'Diseño aprobado. En cola de producción. Tiempo estimado: 2-3 semanas.',
      production_urls: null,
      colors: { primary: '#f97316', secondary: '#fbbf24', accent: '#ec4899', background: '#ffffff', text: '#111827' },
      legal_data: {
        companyName: 'Radio Nueva Actitud S.A.',
        copyright: '© 2026 Radio Nueva Actitud',
        privacyPolicyUrl: 'https://nuevaactitud.com/privacy',
        termsUrl: 'https://nuevaactitud.com/terms',
        supportEmail: 'soporte@nuevaactitud.com',
      },
      social_links: [
        { platform: 'facebook', url: 'https://facebook.com/nuevaactitud' },
        { platform: 'instagram', url: 'https://instagram.com/nuevaactitud' },
      ],
      notes: 'App con player integrado, notificaciones push y chat de cabina.',
    },
    {
      id: 'car-002',
      radio_id: 'radio-nueva-actitud',
      status: 'IN_PRODUCTION',
      app_name: 'Radio Nueva Actitud TV',
      platforms: ['ANDROID_TV', 'FIRE_TV', 'SAMSUNG_TV'],
      requested_at: '2026-06-01T10:00:00Z',
      updated_at: '2026-07-08T15:45:00Z',
      reviewer_notes: 'En producción. Se notificará cuando esté lista para pruebas.',
      production_urls: null,
      colors: { primary: '#f97316', secondary: '#fbbf24', accent: '#ec4899', background: '#0a0a0a', text: '#ffffff' },
      legal_data: {
        companyName: 'Radio Nueva Actitud S.A.',
        copyright: '© 2026 Radio Nueva Actitud',
        privacyPolicyUrl: 'https://nuevaactitud.com/privacy',
        termsUrl: 'https://nuevaactitud.com/terms',
        supportEmail: 'soporte@nuevaactitud.com',
      },
      social_links: [],
      notes: 'Versión TV con interfaz optimizada para control remoto. Incluye visualización de carátula y letras.',
    },
  ],
};